import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class AdjAmortizationListItem extends SearchModelBase {
    id: number = 0;
    postdate: string | null = null;
    fromPostdate: string | null = null;
    toPostdate: string | null = null;
    branch: string = '';
    vendorName: string = '';
    accountName: string = '';
    description: string = '';
    remark: string = '';
    amount: number|null = null;
    fromAmount: number|null = null;
    toAmount: number|null = null;
    u1ID: string = '';
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    status: string = '';


    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        // XCol.Create({ col: 1, text: 'V', width: 40, dataIndex: 'void', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        XCol.Create({ col: 2, text: 'Date', width: 75, dataIndex: 'postdate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Vendor', width: 150, dataIndex: 'vendorName', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'Account Name', width: 150, dataIndex: 'accountName'}),
        XCol.Create({ col: 6, text: 'Description', width: 150, dataIndex: 'description'}),
        XCol.Create({ col: 7, text: 'Amount', width: 100, dataIndex: 'amount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 8, text: 'Remark', width: 200, dataIndex: 'remark'}),
        XCol.Create({ col: 9, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Create by', width: 100, dataIndex: 'u1ID'}),
        XCol.Create({ col: 11, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'Update by', width: 100, dataIndex: 'u2ID'}),
        ];

    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: AdjAmortizationListItem.prototype.postdate, orderByAscending: false };

    public static formatData(data: AdjAmortizationListItem[]) {
        return data.map((d: AdjAmortizationListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        postdate: {from: 'fromPostdate', to: 'toPostdate'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        amount: {from: 'fromAmount', to: 'toAmount'},
    }
}
